<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chi tiết hồ sơ" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsFile"/>
            </vx-tooltip>
        </div>
        <vs-popup title="Chi tiết hồ sơ" :active.sync="popupShowDetailsFile" v-if="popupShowDetailsFile"
                  id="details_file_complete">
            <div class="vx-card" style="min-height: 170px">
                <div class="vx-row">
                    <div class="vx-col w-1/4 py-6 pl-8 info_file_complete">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Khách hàng:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                    <span
                                        class="text-md font-semibold">{{ infoFileData.loyaltyCustomer.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Trạng thái (KH):</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <vs-chip class="ag-grid-cell-chip"
                                                 :color="chipColorCustomerType(infoFileData.customerType)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusCustomerType(infoFileData.customerType)
                                            }}</span>
                                        </vs-chip>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.dateAdmission">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Ngày vào viện:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.dateAdmission }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.diagnostic">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Chẩn đoán:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.diagnostic }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.conclude">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Kết luận:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.conclude }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.consultant">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Tư vấn:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.consultant.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.doctor">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Bác sĩ:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.doctor.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <!--                            <div class="vx-col w-full mb-2" v-if="infoFileData.note">-->
                            <!--                                <div class="vx-row">-->
                            <!--                                    <div class="vx-col lg:w-1/3 w-full">-->
                            <!--                                        <span class="text-md font-semibold">Ghi chú:</span>-->
                            <!--                                    </div>-->
                            <!--                                    <div class="vx-col lg:w-2/3 w-full">-->
                            <!--                                        <span class="text-md">{{ infoFileData.note }}</span>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                    <div class="vx-col w-3/4 py-6 pl-8">
                        <vs-tabs>
                            <vs-tab label="Tư vấn">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                                                  class="w-full input-rounded-full pr-8"
                                                  placeholder="Tìm phiếu theo mã phiếu, mảng dịch vụ hoặc phiếu dịch vụ ..."
                                                  v-model="keySearchConsult"
                                                  @input="searchMedicalConsult"/>
                                    </div>
                                </div>
                                <!--                                <VuePerfectScrollbar ref="scrollDialog"-->
                                <!--                                                     class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6"-->
                                <!--                                                     :settings="settings"-->
                                <!--                                                     style="max-height: 70vh">-->
                                <!--                                    <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
                                <!--                                         v-for="(item, index) in detailsMedicalConsultDataSearch"-->
                                <!--                                         :key="index">-->
                                <!--                                        <div class="medical-bill w-full" @click="showDetailsFileConsult(item)">-->
                                <!--                                            <div class="vx-row m-4">-->
                                <!--                                                <div class="vx-col w-full">-->
                                <!--                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="30px"-->
                                <!--                                                         height="30px" viewBox="0 0 24 24">-->
                                <!--                                                        <path-->
                                <!--                                                            d="M18,23a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H15a1,1,0,0,0-1,1,2,2,0,0,1-4,0A1,1,0,0,0,9,1H6A3,3,0,0,0,3,4V20a3,3,0,0,0,3,3ZM5,20V11h.882a1,1,0,0,0,0-2H5V4A1,1,0,0,1,6,3H8.126a4,4,0,0,0,7.747,0H18a1,1,0,0,1,1,1V9h-.883a1,1,0,0,0,0,2H19v9a1,1,0,0,1-1,1H6A1,1,0,0,1,5,20ZM7.706,10a1,1,0,0,1,1-1h1.882a1,1,0,1,1,0,2H8.706A1,1,0,0,1,7.706,10Zm4.706,0a1,1,0,0,1,1-1h1.882a1,1,0,0,1,0,2H13.412A1,1,0,0,1,12.412,10ZM11,13h2v2h2v2H13v2H11V17H9V15h2Z"/>-->
                                <!--                                                    </svg>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2" v-if="item.beautyMedicalReportNanoCode">-->
                                <!--                                                    <span>Mã phiếu: </span>-->
                                <!--                                                    <span class="text-md font-semibold">-->
                                <!--                                            {{ item.beautyMedicalReportNanoCode }}-->
                                <!--                                        </span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2" v-if="item.beautyGroupService">-->
                                <!--                                                    <span>Mảng dịch vụ: </span>-->
                                <!--                                                    <span class="text-md font-semibold">-->
                                <!--                                            {{-->
                                <!--                                                            item.beautyGroupService.code ? (item.beautyGroupService.code + '-' + item.beautyGroupService.name) : item.beautyGroupService.name-->
                                <!--                                                        }}-->
                                <!--                                        </span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2" v-if="item.beautyService">-->
                                <!--                                                    <span>Nhóm dịch vụ: </span>-->
                                <!--                                                    <span-->
                                <!--                                                        class="text-md font-semibold">{{-->
                                <!--                                                            item.beautyService.code + '-' + item.beautyService.name-->
                                <!--                                                        }}</span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full"-->
                                <!--                                                     v-for="(itemDetails, ind) in item.beautyMedicalReportDetails"-->
                                <!--                                                     :key="ind"-->
                                <!--                                                     v-if="item.beautyMedicalReportDetails.length > 0 && itemDetails && itemDetails.beautyServicePackage">-->
                                <!--                                                    <span class="text-sm">Dịch vụ: </span>-->
                                <!--                                                    <span class="text-sm font-semibold">-->
                                <!--                                            {{-->
                                <!--                                                            itemDetails.beautyServicePackage.code ? (itemDetails.beautyServicePackage.code + '-' + itemDetails.beautyServicePackage.name) : itemDetails.beautyServicePackage.name-->
                                <!--                                                        }}-->
                                <!--                                        </span>-->
                                <!--                                                </div>-->
                                <!--                                                <div-->
                                <!--                                                    class="vx-col w-full flex flex-wrap justify-center items-center gap-4">-->
                                <!--                                                    <span class="text-md font-semibold">Trạng thái:</span>-->
                                <!--                                                    <vs-chip class="ag-grid-cell-chip"-->
                                <!--                                                             :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
                                <!--                                            <span class="text-md font-semibold">-->
                                <!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
                                <!--                                            </span>-->
                                <!--                                                    </vs-chip>-->
                                <!--                                                </div>-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </VuePerfectScrollbar>-->
                                <!--                                <div class="vx-row" v-if="detailsMedicalConsultDataSearch.length === 0">-->
                                <!--                                    <div class="vx-col w-full text-center">-->
                                <!--                                        <span>Không có dữ liệu</span>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div class="mt-6">
                                    <vs-table stripe :data="detailsMedicalConsultDataSearch"
                                              noDataText="Không có dữ liệu">
                                        <template slot="thead">
                                            <vs-th>
                                                STT
                                            </vs-th>
                                            <vs-th>
                                                Mã phiếu
                                            </vs-th>
                                            <vs-th>
                                                Mảng dịch vụ
                                            </vs-th>
                                            <vs-th>
                                                Nhóm dịch vụ
                                            </vs-th>
                                            <vs-th>
                                                Bác sĩ
                                            </vs-th>
                                            <vs-th>
                                                Y tá
                                            </vs-th>
                                            <vs-th>
                                                Lý do
                                            </vs-th>
                                            <vs-th>
                                                Kết luận
                                            </vs-th>
                                            <vs-th>
                                                Trạng thái
                                            </vs-th>
                                            <vs-th>
                                                Hành động
                                            </vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                                <vs-td>
                                                    {{ indextr + 1 }}
                                                </vs-td>
                                                <vs-td>
                                                    {{
                                                        tr.beautyMedicalReportNanoCode ? tr.beautyMedicalReportNanoCode : null
                                                    }}
                                                </vs-td>
                                                <vs-td>
                                                    {{
                                                        tr.beautyGroupService ? (tr.beautyGroupService.code ? (tr.beautyGroupService.code + ' - ' + tr.beautyGroupService.name) : tr.beautyGroupService.name) : null
                                                    }}
                                                </vs-td>
                                                <vs-td>
                                                    <div v-for="(medical, index) in tr.beautyMedicalReportDetails"
                                                         :key="index"
                                                         v-if="tr.beautyMedicalReportDetails.length > 0">
                                                        <vx-tooltip class="position-icon" color="primary"
                                                                    :text="medical.beautyService.code + ' - ' + medical.beautyService.name"
                                                                    position="top" v-if="medical.beautyService">
                                                    <span
                                                        class="text-md font-semibold text-primary whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                        style="width: 150px !important;">
                                                    {{
                                                            medical.beautyService.code + ' - ' + medical.beautyService.name
                                                        }}
                                                    </span>
                                                        </vx-tooltip>
                                                    </div>
                                                </vs-td>
                                                <vs-td>
                                                    {{ tr.doctor }}
                                                </vs-td>
                                                <vs-td>
                                                    {{ tr.nurse }}
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary" :text="tr.reason"
                                                                position="top" v-if="tr.reason">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 150px !important;">
                                                    {{ tr.reason }}
                                                </span>
                                                    </vx-tooltip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary"
                                                                :text="tr.conclude" position="top" v-if="tr.conclude">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 150px !important;">
                                                    {{ tr.conclude }}
                                                </span>
                                                    </vx-tooltip>
                                                </vs-td>
                                                <vs-td>
                                                    <vs-chip class="ag-grid-cell-chip-fee"
                                                             :color="tr.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                tr.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                                                    </vs-chip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" text="Chi tiết" position="top">
                                                        <feather-icon icon="EyeIcon"
                                                                      class="action-success mt-3 text-success"
                                                                      svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                                      @click="showDetailsFileConsult(tr)"/>
                                                    </vx-tooltip>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </vs-tab>
                            <vs-tab label="Thu phí">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                                                  class="w-full input-rounded-full pr-8"
                                                  placeholder="Tìm phiếu theo mã phiếu ..." v-model="keySearchFee"
                                                  @input="searchMedicalFee"/>
                                    </div>
                                </div>
                                <!--                                <VuePerfectScrollbar ref="scrollDialog"-->
                                <!--                                                     class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6"-->
                                <!--                                                     :settings="settings"-->
                                <!--                                                     style="max-height: 70vh">-->
                                <!--                                    <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
                                <!--                                         v-for="(item, index) in detailsMedicalFeeDataSearch"-->
                                <!--                                         :key="index">-->
                                <!--                                        <div class="medical-bill w-full" @click="showDetailsFileFee(item)">-->
                                <!--                                            <div class="vx-row m-4">-->
                                <!--                                                <div class="vx-col w-full">-->
                                <!--                                                    <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"-->
                                <!--                                                         viewBox="0 0 24 24" fill="none">-->
                                <!--                                                        <path-->
                                <!--                                                            d="M21.9199 16.7486C21.5899 19.4086 19.4099 21.5886 16.7499 21.9186C15.1399 22.1186 13.6399 21.6786 12.4699 20.8186C11.7999 20.3286 11.9599 19.2886 12.7599 19.0486C15.7699 18.1386 18.1399 15.7586 19.0599 12.7486C19.2999 11.9586 20.3399 11.7986 20.8299 12.4586C21.6799 13.6386 22.1199 15.1386 21.9199 16.7486Z"-->
                                <!--                                                            fill="#292D32"/>-->
                                <!--                                                        <path-->
                                <!--                                                            d="M9.99 2C5.58 2 2 5.58 2 9.99C2 14.4 5.58 17.98 9.99 17.98C14.4 17.98 17.98 14.4 17.98 9.99C17.97 5.58 14.4 2 9.99 2ZM9.05 8.87L11.46 9.71C12.33 10.02 12.75 10.63 12.75 11.57C12.75 12.65 11.89 13.54 10.84 13.54H10.75V13.59C10.75 14 10.41 14.34 10 14.34C9.59 14.34 9.25 14 9.25 13.59V13.53C8.14 13.48 7.25 12.55 7.25 11.39C7.25 10.98 7.59 10.64 8 10.64C8.41 10.64 8.75 10.98 8.75 11.39C8.75 11.75 9.01 12.04 9.33 12.04H10.83C11.06 12.04 11.24 11.83 11.24 11.57C11.24 11.22 11.18 11.2 10.95 11.12L8.54 10.28C7.68 9.98 7.25 9.37 7.25 8.42C7.25 7.34 8.11 6.45 9.16 6.45H9.25V6.41C9.25 6 9.59 5.66 10 5.66C10.41 5.66 10.75 6 10.75 6.41V6.47C11.86 6.52 12.75 7.45 12.75 8.61C12.75 9.02 12.41 9.36 12 9.36C11.59 9.36 11.25 9.02 11.25 8.61C11.25 8.25 10.99 7.96 10.67 7.96H9.17C8.94 7.96 8.76 8.17 8.76 8.43C8.75 8.77 8.81 8.79 9.05 8.87Z"-->
                                <!--                                                            fill="#292D32"/>-->
                                <!--                                                    </svg>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2">-->
                                <!--                                                    <span>Mã phiếu thu: </span>-->
                                <!--                                                    <span class="text-md font-semibold">{{ item.code }}</span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full flex justify-center items-center gap-4 mb-2">-->
                                <!--                                                    <span class="text-md font-semibold">Loại:</span>-->
                                <!--                                                    <vs-chip class="ag-grid-cell-chip"-->
                                <!--                                                             :color="chipColorTypeFee(item.type)">-->
                                <!--                                        <span-->
                                <!--                                            class="text-md font-semibold">{{-->
                                <!--                                                checkStatusTypeFee(item.type)-->
                                <!--                                            }}</span>-->
                                <!--                                                    </vs-chip>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full flex justify-center items-center gap-4">-->
                                <!--                                                    <span class="text-md font-semibold">Trạng thái:</span>-->
                                <!--                                                    <vs-chip class="ag-grid-cell-chip"-->
                                <!--                                                             :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
                                <!--                                            <span class="text-md font-semibold">-->
                                <!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
                                <!--                                            </span>-->
                                <!--                                                    </vs-chip>-->
                                <!--                                                </div>-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </VuePerfectScrollbar>-->
                                <!--                                <div class="vx-row" v-if="detailsMedicalFeeDataSearch.length === 0">-->
                                <!--                                    <div class="vx-col w-full text-center">-->
                                <!--                                        <span>Không có dữ liệu</span>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div class="mt-6">
                                    <vs-table stripe :data="detailsMedicalFeeDataSearch" noDataText="Không có dữ liệu">
                                        <template slot="thead">
                                            <vs-th>
                                                STT
                                            </vs-th>
                                            <vs-th>
                                                Mã phiếu thu
                                            </vs-th>
                                            <vs-th>
                                                Loại thu phí
                                            </vs-th>
                                            <vs-th>
                                                Combo
                                            </vs-th>
                                            <vs-th>
                                                Nhóm dịch vụ
                                            </vs-th>
                                            <vs-th>
                                                Dịch vụ
                                            </vs-th>
                                            <vs-th>
                                                Ngày thanh toán
                                            </vs-th>
                                            <vs-th>
                                                Tổng tiền (VND)
                                            </vs-th>
                                            <vs-th>
                                                Đã đóng (VND)
                                            </vs-th>
                                            <vs-th>
                                                Trạng thái
                                            </vs-th>
                                            <vs-th>
                                                Hành động
                                            </vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                                <vs-td>
                                                    {{ indextr + 1 }}
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary" :text="tr.code"
                                                                position="top" v-if="tr.code">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 100px !important;">
                                                    {{ tr.code }}
                                                </span>
                                                    </vx-tooltip>
                                                    <!--                                            {{tr.code}}-->
                                                </vs-td>
                                                <vs-td>
                                                    <vs-chip class="ag-grid-cell-chip-fee"
                                                             :color="chipColorType(tr.type)">
                                                <span class="text-md font-semibold">
                                                    {{ checkStatusType(tr.type) }}
                                                </span>
                                                    </vs-chip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary"
                                                                :text="tr.beautyPackageCombo.code + '-' + tr.beautyPackageCombo.name"
                                                                position="top" v-if="tr.beautyPackageCombo">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 150px !important;">
                                                    {{ tr.beautyPackageCombo.code + '-' + tr.beautyPackageCombo.name }}
                                                </span>
                                                    </vx-tooltip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary"
                                                                :text="tr.beautyService.code + '-' + tr.beautyService.name"
                                                                position="top" v-if="tr.beautyService">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 150px !important;">
                                                    {{ tr.beautyService.code + '-' + tr.beautyService.name }}
                                                </span>
                                                    </vx-tooltip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" color="primary"
                                                                :text="tr.beautyServicePackage.code + '-' + tr.beautyServicePackage.name"
                                                                position="top" v-if="tr.beautyServicePackage">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"
                                                          style="width: 150px !important;">
                                                    {{
                                                            tr.beautyServicePackage.code + '-' + tr.beautyServicePackage.name
                                                        }}
                                                </span>
                                                    </vx-tooltip>
                                                </vs-td>
                                                <vs-td>
                                                    {{ tr.paymentDateStr }}
                                                </vs-td>
                                                <vs-td>
                                                    {{ tr.total ? numberWithCommas(tr.total) : 0 }}
                                                </vs-td>
                                                <vs-td>
                                                    {{ tr.amountPaid ? numberWithCommas(tr.amountPaid) : 0 }}
                                                </vs-td>
                                                <vs-td>
                                                    <vs-chip class="ag-grid-cell-chip-fee"
                                                             :color="tr.settingMedicalExaminationStep.medicalExaminationStep.color">
                                                <span
                                                    class="text-md font-semibold">{{
                                                        tr.settingMedicalExaminationStep.medicalExaminationStep.name
                                                    }}
                                                </span>
                                                    </vs-chip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" text="Chi tiết" position="top">
                                                        <feather-icon icon="EyeIcon"
                                                                      class="action-success mt-3 text-success"
                                                                      svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                                      @click="showDetailsFileFee(tr)"/>
                                                    </vx-tooltip>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </vs-tab>
                            <vs-tab label="Cận lâm sàng">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                                                  class="w-full input-rounded-full pr-8"
                                                  placeholder="Tìm phiếu theo mã phiếu ..." v-model="keySearchExam"
                                                  @input="searchMedicalExam"/>
                                    </div>
                                </div>
                                <!--                                <VuePerfectScrollbar ref="scrollDialog"-->
                                <!--                                                     class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6 match-height"-->
                                <!--                                                     :settings="settings"-->
                                <!--                                                     style="max-height: 70vh">-->
                                <!--                                    <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
                                <!--                                         v-for="(item, index) in detailsMedicalExamDataSearch"-->
                                <!--                                         :key="index">-->
                                <!--                                        <div class="medical-bill w-full" @click="showDetailsFileExam(item)">-->
                                <!--                                            <div class="vx-row m-4">-->
                                <!--                                                <div class="vx-col w-full">-->
                                <!--                                                    <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"-->
                                <!--                                                         viewBox="0 0 24 24" fill="none">-->
                                <!--                                                        <path fill-rule="evenodd" clip-rule="evenodd"-->
                                <!--                                                              d="M12 11.75C12.4142 11.75 12.75 12.0858 12.75 12.5V13.25H13.5C13.9142 13.25 14.25 13.5858 14.25 14C14.25 14.4142 13.9142 14.75 13.5 14.75H12.75V15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5V14.75H10.5C10.0858 14.75 9.75 14.4142 9.75 14C9.75 13.5858 10.0858 13.25 10.5 13.25H11.25V12.5C11.25 12.0858 11.5858 11.75 12 11.75Z"-->
                                <!--                                                              fill="#1C274C"/>-->
                                <!--                                                        <path fill-rule="evenodd" clip-rule="evenodd"-->
                                <!--                                                              d="M11.948 1.25C11.0495 1.24997 10.3003 1.24995 9.70552 1.32991C9.07773 1.41432 8.51093 1.59999 8.05546 2.05546C7.59999 2.51093 7.41432 3.07773 7.32991 3.70552C7.24995 4.3003 7.24997 5.04952 7.25 5.948L7.25 6.02572C5.22882 6.09185 4.01511 6.32803 3.17157 7.17158C2 8.34315 2 10.2288 2 14C2 17.7712 2 19.6569 3.17157 20.8284C4.34314 22 6.22876 22 9.99998 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14C22 10.2288 22 8.34315 20.8284 7.17158C19.9849 6.32803 18.7712 6.09185 16.75 6.02572L16.75 5.94801C16.75 5.04954 16.7501 4.3003 16.6701 3.70552C16.5857 3.07773 16.4 2.51093 15.9445 2.05546C15.4891 1.59999 14.9223 1.41432 14.2945 1.32991C13.6997 1.24995 12.9505 1.24997 12.052 1.25H11.948ZM15.25 6.00189V6C15.25 5.03599 15.2484 4.38843 15.1835 3.9054C15.1214 3.44393 15.0142 3.24644 14.8839 3.11612C14.7536 2.9858 14.5561 2.87858 14.0946 2.81654C13.6116 2.7516 12.964 2.75 12 2.75C11.036 2.75 10.3884 2.7516 9.90539 2.81654C9.44393 2.87858 9.24643 2.9858 9.11612 3.11612C8.9858 3.24644 8.87858 3.44393 8.81654 3.9054C8.75159 4.38843 8.75 5.03599 8.75 6V6.00189C9.14203 6 9.55807 6 10 6H14C14.4419 6 14.858 6 15.25 6.00189ZM16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14Z"-->
                                <!--                                                              fill="#1C274C"/>-->
                                <!--                                                    </svg>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2 flex flex-wrap justify-center">-->
                                <!--                                                    <span>Mã phiếu:</span>-->
                                <!--                                                    <span class="text-md font-semibold">{{-->
                                <!--                                                            item.beautySubclinicalNanoCode-->
                                <!--                                                        }}</span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2 flex flex-wrap justify-center">-->
                                <!--                                                    <span>Thời gian thực hiện: </span>-->
                                <!--                                                    <span class="text-md font-semibold">{{-->
                                <!--                                                            item.hospitalAdmissionDateStr-->
                                <!--                                                        }}</span>-->
                                <!--                                                </div>-->
                                <!--                                                <div class="vx-col w-full mb-2 flex flex-wrap justify-center"-->
                                <!--                                                     v-if="item.beautyService">-->
                                <!--                                                    <span>Dịch vụ: </span>-->
                                <!--                                                    <span class="text-md font-semibold">{{-->
                                <!--                                                            item.beautyService.code + '-' + item.beautyService.name-->
                                <!--                                                        }}</span>-->
                                <!--                                                </div>-->
                                <!--                                                <div-->
                                <!--                                                    class="vx-col w-full flex flex-wrap justify-center items-center gap-4">-->
                                <!--                                                    <span class="text-md font-semibold">Trạng thái:</span>-->
                                <!--                                                    <vs-chip class="ag-grid-cell-chip"-->
                                <!--                                                             :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
                                <!--                                            <span class="text-md font-semibold">-->
                                <!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
                                <!--                                            </span>-->
                                <!--                                                    </vs-chip>-->
                                <!--                                                </div>-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </VuePerfectScrollbar>-->
                                <!--                                <div class="vx-row" v-if="detailsMedicalExamDataSearch.length === 0">-->
                                <!--                                    <div class="vx-col w-full text-center">-->
                                <!--                                        <span>Không có dữ liệu</span>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div class="mt-6">
                                    <vs-table stripe :data="detailsMedicalExamDataSearch" noDataText="Không có dữ liệu">
                                        <template slot="thead">
                                            <vs-th>
                                                STT
                                            </vs-th>
                                            <vs-th>
                                                Mã phiếu
                                            </vs-th>
                                            <vs-th>
                                                Thời gian thực hiện
                                            </vs-th>
                                            <vs-th>
                                                Mảng dịch vụ
                                            </vs-th>
                                            <!--                                            <vs-th>-->
                                            <!--                                                Nhóm dịch vụ-->
                                            <!--                                            </vs-th>-->
                                            <!--                                            <vs-th>-->
                                            <!--                                                Bác sĩ-->
                                            <!--                                            </vs-th>-->
                                            <!--                                            <vs-th>-->
                                            <!--                                                Y tá-->
                                            <!--                                            </vs-th>-->
                                            <!--                                            <vs-th>-->
                                            <!--                                                Lý do-->
                                            <!--                                            </vs-th>-->
                                            <!--                                            <vs-th>-->
                                            <!--                                                Kết luận-->
                                            <!--                                            </vs-th>-->
                                            <vs-th>
                                                Trạng thái
                                            </vs-th>
                                            <vs-th>
                                                Hành động
                                            </vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                                <vs-td>
                                                    {{ indextr + 1 }}
                                                </vs-td>
                                                <vs-td>
                                                    {{
                                                        tr.beautySubclinicalNanoCode ? tr.beautySubclinicalNanoCode : null
                                                    }}
                                                </vs-td>
                                                <vs-td>
                                                    {{
                                                        tr.hospitalAdmissionDateStr ? tr.hospitalAdmissionDateStr : null
                                                    }}
                                                </vs-td>
                                                <vs-td>
                                                    {{
                                                        tr.beautyService ? (tr.beautyService.code + ' - ' + tr.beautyService.name) : null
                                                    }}
                                                </vs-td>
                                                <!--                                                <vs-td>-->
                                                <!--                                                    <div v-for="(medical, index) in tr.beautyMedicalReportDetails"-->
                                                <!--                                                         :key="index"-->
                                                <!--                                                         v-if="tr.beautyMedicalReportDetails.length > 0">-->
                                                <!--                                                        <vx-tooltip class="position-icon" color="primary"-->
                                                <!--                                                                    :text="medical.beautyService.code + ' - ' + medical.beautyService.name"-->
                                                <!--                                                                    position="top" v-if="medical.beautyService">-->
                                                <!--                                                    <span-->
                                                <!--                                                        class="text-md font-semibold text-primary whitespace-no-wrap overflow-hidden text-ellipsis block"-->
                                                <!--                                                        style="width: 150px !important;">-->
                                                <!--                                                    {{-->
                                                <!--                                                            medical.beautyService.code + ' - ' + medical.beautyService.name-->
                                                <!--                                                        }}-->
                                                <!--                                                    </span>-->
                                                <!--                                                        </vx-tooltip>-->
                                                <!--                                                    </div>-->
                                                <!--                                                </vs-td>-->
                                                <!--                                                <vs-td>-->
                                                <!--                                                    {{ tr.doctor }}-->
                                                <!--                                                </vs-td>-->
                                                <!--                                                <vs-td>-->
                                                <!--                                                    {{ tr.nurse }}-->
                                                <!--                                                </vs-td>-->
                                                <!--                                                <vs-td>-->
                                                <!--                                                    <vx-tooltip class="position-icon" color="primary" :text="tr.reason"-->
                                                <!--                                                                position="top" v-if="tr.reason">-->
                                                <!--                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"-->
                                                <!--                                                          style="width: 150px !important;">-->
                                                <!--                                                    {{ tr.reason }}-->
                                                <!--                                                </span>-->
                                                <!--                                                    </vx-tooltip>-->
                                                <!--                                                </vs-td>-->
                                                <!--                                                <vs-td>-->
                                                <!--                                                    <vx-tooltip class="position-icon" color="primary"-->
                                                <!--                                                                :text="tr.conclude" position="top" v-if="tr.conclude">-->
                                                <!--                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block"-->
                                                <!--                                                          style="width: 150px !important;">-->
                                                <!--                                                    {{ tr.conclude }}-->
                                                <!--                                                </span>-->
                                                <!--                                                    </vx-tooltip>-->
                                                <!--                                                </vs-td>-->
                                                <vs-td>
                                                    <vs-chip class="ag-grid-cell-chip-fee"
                                                             :color="tr.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                tr.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                                                    </vs-chip>
                                                </vs-td>
                                                <vs-td>
                                                    <vx-tooltip class="position-icon" text="Chi tiết" position="top">
                                                        <feather-icon icon="EyeIcon"
                                                                      class="action-success mt-3 text-success"
                                                                      svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                                      @click="showDetailsFileExam(tr)"/>
                                                    </vx-tooltip>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </div>
            <vs-popup class="holamundo" id="details_file_consult_popup"
                      :active.sync="isShowDetailsFileConsult">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu khám</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFileConsult"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="medicalConsultInfo && medicalConsultInfo.beautyMedicalReportNanoCode">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mã phiếu:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalConsultInfo.beautyMedicalReportNanoCode
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.beautyGroupService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mảng dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalConsultInfo.beautyGroupService.code ? (medicalConsultInfo.beautyGroupService.code + '-' + medicalConsultInfo.beautyGroupService.name) : medicalConsultInfo.beautyGroupService.name
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.beautyService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalConsultInfo.beautyService.code + '-' + medicalConsultInfo.beautyService.name
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4"
                     v-if="medicalConsultInfo && medicalConsultInfo.beautyMedicalReportDetails.length > 0">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <div class="vx-row" v-for="(medical, index) in medicalConsultInfo.beautyMedicalReportDetails"
                             :key="index"
                             v-if="medical && medical.beautyService">
                            <div class="vx-col w-full">
                            <span class="text-md font-semibold text-primary">
                                {{ medical.beautyService.code + '-' + medical.beautyService.name }}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.hospitalAdmissionDate">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Ngày vào viện:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalConsultInfo.hospitalAdmissionDate }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.doctor">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Bác sĩ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalConsultInfo.doctor.fullName }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.nurse">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Y tá:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalConsultInfo.nurse.fullName }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.reason">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Lý do:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalConsultInfo.reason }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.conclude">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Kết luận:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalConsultInfo.conclude }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalConsultInfo && medicalConsultInfo.settingMedicalExaminationStep">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="medicalConsultInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                medicalConsultInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" id="details_file_popup"
                      :active.sync="isShowDetailsFileFee">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu thu</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFileFee"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="feeReceiptInfo && feeReceiptInfo.code">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mã phiếu thu:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <span class="text-md font-semibold text-primary">{{ feeReceiptInfo.code }}</span>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="feeReceiptInfo && feeReceiptInfo.type">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Loại:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="chipColorType(feeReceiptInfo.type)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusType(feeReceiptInfo.type)
                                            }}</span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="feeReceiptInfo">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="feeReceiptInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                feeReceiptInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyPackageCombo">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Combo:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyPackageCombo.code + '-' + feeReceiptInfo.beautyPackageCombo.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyService.code + '-' + feeReceiptInfo.beautyService.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.beautyServicePackage">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.beautyServicePackage.code + '-' + feeReceiptInfo.beautyServicePackage.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.paymentDate">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Ngày đóng tiền:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.paymentDate }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.total">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Tổng tiền:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md text-primary font-semibold">
                        {{ feeReceiptInfo.total }} VND
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.amountPaid">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Đã đóng:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md text-warning font-semibold">
                        {{ feeReceiptInfo.amountPaid }} VND
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="feeReceiptInfo && feeReceiptInfo.note">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Ghi chú:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ feeReceiptInfo.note }}
                    </span>
                    </div>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" id="details_file_exam_popup"
                      :active.sync="isShowDetailsFileExam">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFileExam"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="examinationtInfo && examinationtInfo.beautySubclinicalNanoCode">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Mã phiếu:</span>
                    </div>
                    <div class="vx-col w-2/3">
                    <span class="text-md font-semibold text-primary">{{
                            examinationtInfo.beautySubclinicalNanoCode
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="examinationtInfo && examinationtInfo.hospitalAdmissionDateStr">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Thời gian thực hiện:</span>
                    </div>
                    <div class="vx-col w-2/3">
                        <span class="text-md">{{ examinationtInfo.hospitalAdmissionDateStr }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="examinationtInfo && examinationtInfo.beautyService">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col w-2/3">
                    <span class="text-md font-semibold text-primary">
                        {{ examinationtInfo.beautyService.code + ' - ' + examinationtInfo.beautyService.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="examinationtInfo">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="examinationtInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                examinationtInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-6"
                     v-if="examinationtInfo && examinationtInfo.beautySubclinicalDetails.length > 0">
                    <div class="vx-col w-full md:flex" v-for="(item, ind) in examinationtInfo.beautySubclinicalDetails"
                         :key="ind">
                        <div class="md:flex justify-center items-center icon-subclinical-details mr-2 hidden">
                            <feather-icon icon="PackageIcon" class="text-primary" svgClasses="h-8 w-8"/>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full flex justify-between">
                            <span class="text-md font-semibold text-primary">
                                {{
                                    item.beautyServicePackage ? (item.beautyServicePackage.code + ' - ' + item.beautyServicePackage.name) : item.beautyPackageCombo ? (item.beautyPackageCombo.code + ' - ' + item.beautyPackageCombo.name) : null
                                }}
                            </span>
                                <span class="text-md font-semibold text-primary">{{
                                        numberWithCommas(item.unitPrice) + ' VND'
                                    }}</span>
                            </div>
                            <div class="vx-col w-full flex justify-between">
                                <vs-chip class="ag-grid-cell-chip" :color="item.allIn ? 'warning' : 'primary'">
                                    <span class="text-md font-semibold">{{ item.allIn ? 'Combo' : 'Dịch vụ lẻ' }}</span>
                                </vs-chip>
                                <vs-chip class="ag-grid-cell-chip" :color="item.paid === 0 ? 'danger' : 'success'">
                                    <span class="text-md font-semibold">{{
                                            item.paid === 0 ? 'Chưa thanh toán' : 'Đã thanh toán'
                                        }}</span>
                                </vs-chip>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" id="show_imd_analysation" title="Kết quả chẩn đoán hình ảnh" fullscreen  :active.sync="showImgAnalysation" v-if="showImgAnalysation">
                <div v-for="(img, ind) in dataImgAnalysation" :key="ind" class="mb-4 last:mb-0" v-if="dataImgAnalysation.length > 0">
                    <h2 class="text-primary font-bold">{{ 'Hình ảnh ' + (ind + 1) }}</h2>
                    <img :src="img" alt=""  style="width: 100%; height: auto"/>
                </div>
                <div v-else>
                    <span>Không có dữ liệu</span>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";

export default {
    name: "CellRendererActionsComplete",
    components: {
        VuePerfectScrollbar
    },

    data() {
        return {
            popupShowDetailsFile: false,
            infoFileData: null,
            detailsMedicalConsultData: [],
            detailsMedicalConsultDataSearch: [],
            medicalConsultInfo: null,
            isShowDetailsFileConsult: false,
            keySearchConsult: null,
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            keySearchFee: null,
            feeReceiptInfo: null,
            isShowDetailsFileFee: false,
            detailsMedicalFeeData: [],
            detailsMedicalFeeDataSearch: [],
            keySearchExam: null,
            detailsMedicalExamData: [],
            detailsMedicalExamDataSearch: [],
            examinationtInfo: null,
            isShowDetailsFileExam: false,
            showImgAnalysation: false,
            dataImgAnalysation: [],
        }
    },

    computed: {
        chipColorCustomerType() {
            return value => {
                if (value === 1) {
                    return "success";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'warning'
                } else if (value === 6) {
                    return 'danger'
                } else if (value === 7) {
                    return 'warning'
                }
            }
        },
        checkStatusCustomerType() {
            return value => {
                if (value === 1) {
                    return "Khách hàng cũ tới tái khám";
                } else if (value === 2) {
                    return "Khách hàng cũ sử dụng dịch vụ"
                } else if (value === 3) {
                    return "Khách hàng cũ tới tư vấn dịch vụ"
                } else if (value === 4) {
                    return "Khách hàng mới đến tư vấn"
                } else if (value === 5) {
                    return "Khách hàng tới mua thuốc mỹ phẩm"
                } else if (value === 6) {
                    return "Khách hàng trả lại thuốc"
                } else if (value === 7) {
                    return "Khách hàng tới hoàn phí"
                }
            }
        },
        chipColorTypeFee() {
            return value => {
                if (value === 1) {
                    return "primary";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'primary'
                }
            }
        },
        checkStatusTypeFee() {
            return value => {
                if (value === 1) {
                    return "Thu phí dịch vụ";
                } else if (value === 2) {
                    return "Thu phí combo"
                } else if (value === 3) {
                    return "Thu phí thuốc"
                } else if (value === 4) {
                    return "Công nợ"
                } else if (value === 5) {
                    return "Tạm ứng"
                }
            }
        },
        chipColorType() {
            return value => {
                if (value === 1) {
                    return "primary";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'primary'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value === 1) {
                    return "Thu phí dịch vụ";
                } else if (value === 2) {
                    return "Thu phí combo"
                } else if (value === 3) {
                    return "Thu phí thuốc"
                } else if (value === 4) {
                    return "Công nợ"
                } else if (value === 5) {
                    return "Tạm ứng"
                }
            }
        },
    },

    methods: {
        detailsFile() {
            this.infoFileData = this.params.data;
            this.infoFileData.dateAdmission = this.infoFileData.dateAdmission.includes('/') ? this.infoFileData.dateAdmission : moment(this.infoFileData.dateAdmission).format('DD/MM/YYYY');
            this.detailsMedicalConsultData = this.infoFileData.beautyMedicalReports.map(el => {
                el.hospitalAdmissionDate = el.hospitalAdmissionDate.includes('/') ? el.hospitalAdmissionDate : moment(el.hospitalAdmissionDate).format('DD/MM/YYYY');
                return el;
            });
            this.detailsMedicalConsultDataSearch = this.detailsMedicalConsultData;
            this.detailsMedicalFeeData = this.infoFileData.beautyCollectFees;
            this.detailsMedicalFeeDataSearch = this.detailsMedicalFeeData;
            this.detailsMedicalExamData = this.infoFileData.beautySubclinicals;
            this.detailsMedicalExamData.forEach(el => {
                el.hospitalAdmissionDateStr = el.hospitalAdmissionDate ? moment(el.hospitalAdmissionDate).format('DD/MM/YYYY') : null;
            })
            this.detailsMedicalExamDataSearch = this.detailsMedicalExamData;
            this.popupShowDetailsFile = true;
        },

        showDetailsFileConsult(item) {
            this.medicalConsultInfo = null;
            this.medicalConsultInfo = item;
            this.isShowDetailsFileConsult = true
        },

        closeDetailsFileConsult() {
            this.isShowDetailsFileConsult = false;
            this.medicalConsultInfo = null;
        },

        searchMedicalConsult(event) {
            let str = event.toLowerCase();
            this.detailsMedicalConsultDataSearch = this.detailsMedicalConsultData.filter(el => (el.beautyService ? (el.beautyService.name.toLowerCase().includes(str) || el.beautyService.code.toLowerCase().includes(str) || el.beautyMedicalReportNanoCode.toLowerCase().includes(str)) : el.beautyMedicalReportNanoCode.toLowerCase().includes(str)) || (el.beautyGroupService ? el.beautyGroupService.name.toLowerCase().includes(str) : false));
        },

        searchMedicalFee(event) {
            let str = event.toLowerCase();
            this.detailsMedicalFeeDataSearch = this.detailsMedicalFeeData.filter(el => el.code.toLowerCase().includes(str))
        },

        showDetailsFileFee(data) {
            this.feeReceiptInfo = null;
            this.feeReceiptInfo = data;
            this.feeReceiptInfo.paymentDate = data.paymentDate ? (data.paymentDate.includes('/') ? data.paymentDate : moment(data.paymentDate).format('DD/MM/YYYY HH:mm:ss')) : null;
            this.feeReceiptInfo.total = data.total ? this.numberWithCommas(data.total) : null;
            this.feeReceiptInfo.amountPaid = data.amountPaid ? this.numberWithCommas(data.amountPaid) : null;
            setTimeout(() => {
                this.isShowDetailsFileFee = true
            }, 100)
        },

        closeDetailsFileFee() {
            this.isShowDetailsFileFee = false;
            this.feeReceiptInfo = null;
        },

        numberWithCommas(x) {
            x = x.toString();
            let pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x))
                x = x.replace(pattern, "$1,$2");
            return x;
        },

        searchMedicalExam(event) {
            let str = event.toLowerCase();
            this.detailsMedicalExamDataSearch = this.detailsMedicalExamData.filter(el => el.beautySubclinicalNanoCode.toLowerCase().includes(str))
        },

        async showDetailsFileExam(data) {
            if (data.type != 2) {
                this.examinationtInfo = null;
                this.examinationtInfo = data;
                setTimeout(() => {
                    this.isShowDetailsFileExam = true
                }, 100)
            } else {
                await this.getImageAnalysation();
                if (this.dataImgAnalysation.length === 0) {
                    return this.$vs.notify({
                        text: 'Không có dữ liệu hình ảnh!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.showImgAnalysation = true;
            }
        },

        closeDetailsFileExam() {
            this.isShowDetailsFileExam = false;
        },

        getImageAnalysation() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-subclinical/get-image-analysation-by-subclinical-id/${this.params.data.id}`).then(res => {
                    this.$vs.loading.close();
                    if (res.data.base64Images.length > 0) {
                        const prefix = "data:image/jpeg;base64,";
                        this.dataImgAnalysation = res.data.base64Images.map(x => prefix + x);
                    } else {
                        this.dataImgAnalysation = []
                    }

                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        }
    }
}
</script>

<style lang="scss">
#details_file_complete {
    .vs-popup {
        width: 100% !important;
    }

    .info_file_complete {
        border-right: 1px solid #dbdade;
    }

    .medical-bill {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        min-height: 150px;
        cursor: pointer;
    }

    .medical-bill:hover {
        color: rgba(var(--vs-primary), 1);
        border: 1px solid rgba(var(--vs-primary), 1);

        svg {
            fill: rgba(var(--vs-primary), 1);
        }
    }
}

#details_file_consult_popup {
    .vs-popup--header {
        display: none;
    }
}

#details_file_fee_popup {
    .vs-popup--header {
        display: none;
    }
}

#details_file_exam_popup {
    .vs-popup--header {
        display: none;
    }

    .icon-subclinical-details {
        background-color: rgba(var(--vs-primary), .15);
        width: 50px;
        border-radius: 0.375rem;
    }
}

.ag-grid-cell-chip-fee {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .15);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-cancel {
        background: rgba(var(--vs-cancel), .15);
        color: rgba(var(--vs-cancel), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-primary {
        background: rgba(var(--vs-primary), .15);
        color: rgba(var(--vs-primary), 1) !important;
        font-weight: 500;
    }
}
</style>
